import {
  RecordActionTypes,
  RecordsState,
  RecordSubState,
  YogaRecord,
  HomeVisitRecord,
  InterestCheckRecord,
  MCITestRecord,
  LifeCheckRecord,
  BarthelRecord,
  MoffTrainingRecord,
} from '../../constants/Records';

// サブステートの初期値を生成するヘルパー
function createInitialSubState<T>(): RecordSubState<T> {
  return {
    list: [],
    current: null,
    executing: false,
    loaded: false,
    created: false,
    updated: false,
    deleted: false,
  };
}

export const initialState: RecordsState = {
  currentUser: {
    unique_id: null,
    userId: null,
    userName: null,
    institutionId: null,
    institutionName: null,
  },
  counts: {
    moffcheck: 0,
    mofftraining: 0,
    yoga: 0,
    homevisit: 0,
    interest: 0,
    mci: 0,
    lifecheck: 0,
    barthel: 0,
    loading: false,
  },
  yoga: createInitialSubState<YogaRecord>(),
  yogaMenus: [],
  homevisit: createInitialSubState<HomeVisitRecord>(),
  interest: createInitialSubState<InterestCheckRecord>(),
  mci: createInitialSubState<MCITestRecord>(),
  lifecheck: createInitialSubState<LifeCheckRecord>(),
  barthel: createInitialSubState<BarthelRecord>(),
  mofftraining: createInitialSubState<MoffTrainingRecord>(),
  trainingMenus: [],
  error: null,
};

export default function records(state = initialState, action: any): RecordsState {
  switch (action.type) {
    // 共通
    case RecordActionTypes.SET_CURRENT_USER:
      return {
        ...state,
        currentUser: action.payload,
      };

    case RecordActionTypes.RESET:
      return initialState;

    case RecordActionTypes.API_ERROR:
      return {
        ...state,
        yoga: {
          ...state.yoga,
          executing: false,
        },
        homevisit: {
          ...state.homevisit,
          executing: false,
        },
        interest: {
          ...state.interest,
          executing: false,
        },
        mci: {
          ...state.mci,
          executing: false,
        },
        lifecheck: {
          ...state.lifecheck,
          executing: false,
        },
        barthel: {
          ...state.barthel,
          executing: false,
        },
        mofftraining: {
          ...state.mofftraining,
          executing: false,
        },
        error: action.error,
      };

    // レコード件数取得
    case RecordActionTypes.FETCH_ALL_COUNTS_START:
      return {
        ...state,
        counts: {
          ...state.counts,
          loading: true,
        },
      };

    case RecordActionTypes.FETCH_ALL_COUNTS_FINISH:
      return {
        ...state,
        counts: {
          ...action.payload,
          loading: false,
        },
      };

    // Yoga
    case RecordActionTypes.YOGA_START_FETCH:
      return {
        ...state,
        yoga: {
          ...state.yoga,
          executing: true,
        },
      };

    case RecordActionTypes.YOGA_FINISH_FETCH:
      return {
        ...state,
        yoga: {
          ...state.yoga,
          list: action.payload.records,
          executing: false,
          loaded: true,
        },
        yogaMenus: action.payload.menus || state.yogaMenus,
      };

    case RecordActionTypes.YOGA_START_FETCH_ONE:
      return {
        ...state,
        yoga: {
          ...state.yoga,
          executing: true,
        },
      };

    case RecordActionTypes.YOGA_FINISH_FETCH_ONE:
      return {
        ...state,
        yoga: {
          ...state.yoga,
          current: action.payload,
          executing: false,
        },
      };

    case RecordActionTypes.YOGA_START_CREATE:
      return {
        ...state,
        yoga: {
          ...state.yoga,
          executing: true,
          created: false,
        },
      };

    case RecordActionTypes.YOGA_FINISH_CREATE:
      return {
        ...state,
        yoga: {
          ...state.yoga,
          list: [...state.yoga.list, action.payload],
          executing: false,
          created: true,
        },
      };

    case RecordActionTypes.YOGA_START_UPDATE:
      return {
        ...state,
        yoga: {
          ...state.yoga,
          executing: true,
          updated: false,
        },
      };

    case RecordActionTypes.YOGA_FINISH_UPDATE:
      return {
        ...state,
        yoga: {
          ...state.yoga,
          list: state.yoga.list.map(r =>
            r.unique_id === action.payload.unique_id && r.record_time === action.payload.record_time
              ? action.payload
              : r,
          ),
          current: action.payload,
          executing: false,
          updated: true,
        },
      };

    case RecordActionTypes.YOGA_START_DELETE:
      return {
        ...state,
        yoga: {
          ...state.yoga,
          executing: true,
          deleted: false,
        },
      };

    case RecordActionTypes.YOGA_FINISH_DELETE:
      return {
        ...state,
        yoga: {
          ...state.yoga,
          list: state.yoga.list.filter(
            r => !(r.unique_id === action.payload.unique_id && r.record_time === action.payload.record_time),
          ),
          current: null,
          executing: false,
          deleted: true,
        },
      };

    case RecordActionTypes.YOGA_RESET_FLAGS:
      return {
        ...state,
        yoga: {
          ...state.yoga,
          created: false,
          updated: false,
          deleted: false,
        },
      };

    // HomeVisit
    case RecordActionTypes.HOMEVISIT_START_FETCH:
      return {
        ...state,
        homevisit: {
          ...state.homevisit,
          executing: true,
        },
      };

    case RecordActionTypes.HOMEVISIT_FINISH_FETCH:
      return {
        ...state,
        homevisit: {
          ...state.homevisit,
          list: action.payload,
          executing: false,
          loaded: true,
        },
      };

    case RecordActionTypes.HOMEVISIT_START_FETCH_ONE:
      return {
        ...state,
        homevisit: {
          ...state.homevisit,
          executing: true,
        },
      };

    case RecordActionTypes.HOMEVISIT_FINISH_FETCH_ONE:
      return {
        ...state,
        homevisit: {
          ...state.homevisit,
          current: action.payload,
          executing: false,
        },
      };

    case RecordActionTypes.HOMEVISIT_START_CREATE:
      return {
        ...state,
        homevisit: {
          ...state.homevisit,
          executing: true,
          created: false,
        },
      };

    case RecordActionTypes.HOMEVISIT_FINISH_CREATE:
      return {
        ...state,
        homevisit: {
          ...state.homevisit,
          list: [...state.homevisit.list, action.payload],
          executing: false,
          created: true,
        },
      };

    case RecordActionTypes.HOMEVISIT_START_UPDATE:
      return {
        ...state,
        homevisit: {
          ...state.homevisit,
          executing: true,
          updated: false,
        },
      };

    case RecordActionTypes.HOMEVISIT_FINISH_UPDATE:
      return {
        ...state,
        homevisit: {
          ...state.homevisit,
          list: state.homevisit.list.map(r =>
            r.unique_id === action.payload.unique_id && r.sequence === action.payload.sequence ? action.payload : r,
          ),
          current: action.payload,
          executing: false,
          updated: true,
        },
      };

    case RecordActionTypes.HOMEVISIT_START_DELETE:
      return {
        ...state,
        homevisit: {
          ...state.homevisit,
          executing: true,
          deleted: false,
        },
      };

    case RecordActionTypes.HOMEVISIT_FINISH_DELETE:
      return {
        ...state,
        homevisit: {
          ...state.homevisit,
          list: state.homevisit.list.filter(
            r => !(r.unique_id === action.payload.unique_id && r.sequence === action.payload.sequence),
          ),
          current: null,
          executing: false,
          deleted: true,
        },
      };

    case RecordActionTypes.HOMEVISIT_RESET_FLAGS:
      return {
        ...state,
        homevisit: {
          ...state.homevisit,
          created: false,
          updated: false,
          deleted: false,
        },
      };

    // Interest
    case RecordActionTypes.INTEREST_START_FETCH:
      return {
        ...state,
        interest: {
          ...state.interest,
          executing: true,
        },
      };

    case RecordActionTypes.INTEREST_FINISH_FETCH:
      return {
        ...state,
        interest: {
          ...state.interest,
          list: action.payload,
          executing: false,
          loaded: true,
        },
      };

    case RecordActionTypes.INTEREST_START_FETCH_ONE:
      return {
        ...state,
        interest: {
          ...state.interest,
          executing: true,
        },
      };

    case RecordActionTypes.INTEREST_FINISH_FETCH_ONE:
      return {
        ...state,
        interest: {
          ...state.interest,
          current: action.payload,
          executing: false,
        },
      };

    case RecordActionTypes.INTEREST_START_CREATE:
      return {
        ...state,
        interest: {
          ...state.interest,
          executing: true,
          created: false,
        },
      };

    case RecordActionTypes.INTEREST_FINISH_CREATE:
      return {
        ...state,
        interest: {
          ...state.interest,
          list: [...state.interest.list, action.payload],
          executing: false,
          created: true,
        },
      };

    case RecordActionTypes.INTEREST_START_UPDATE:
      return {
        ...state,
        interest: {
          ...state.interest,
          executing: true,
          updated: false,
        },
      };

    case RecordActionTypes.INTEREST_FINISH_UPDATE:
      return {
        ...state,
        interest: {
          ...state.interest,
          list: state.interest.list.map(r =>
            r.unique_id === action.payload.unique_id && r.sequence === action.payload.sequence ? action.payload : r,
          ),
          current: action.payload,
          executing: false,
          updated: true,
        },
      };

    case RecordActionTypes.INTEREST_START_DELETE:
      return {
        ...state,
        interest: {
          ...state.interest,
          executing: true,
          deleted: false,
        },
      };

    case RecordActionTypes.INTEREST_FINISH_DELETE:
      return {
        ...state,
        interest: {
          ...state.interest,
          list: state.interest.list.filter(
            r => !(r.unique_id === action.payload.unique_id && r.sequence === action.payload.sequence),
          ),
          current: null,
          executing: false,
          deleted: true,
        },
      };

    case RecordActionTypes.INTEREST_RESET_FLAGS:
      return {
        ...state,
        interest: {
          ...state.interest,
          created: false,
          updated: false,
          deleted: false,
        },
      };

    // MCI
    case RecordActionTypes.MCI_START_FETCH:
      return {
        ...state,
        mci: {
          ...state.mci,
          executing: true,
        },
      };

    case RecordActionTypes.MCI_FINISH_FETCH:
      return {
        ...state,
        mci: {
          ...state.mci,
          list: action.payload,
          executing: false,
          loaded: true,
        },
      };

    case RecordActionTypes.MCI_START_FETCH_ONE:
      return {
        ...state,
        mci: {
          ...state.mci,
          executing: true,
        },
      };

    case RecordActionTypes.MCI_FINISH_FETCH_ONE:
      return {
        ...state,
        mci: {
          ...state.mci,
          current: action.payload,
          executing: false,
        },
      };

    case RecordActionTypes.MCI_START_CREATE:
      return {
        ...state,
        mci: {
          ...state.mci,
          executing: true,
          created: false,
        },
      };

    case RecordActionTypes.MCI_FINISH_CREATE:
      return {
        ...state,
        mci: {
          ...state.mci,
          list: [...state.mci.list, action.payload],
          executing: false,
          created: true,
        },
      };

    case RecordActionTypes.MCI_START_UPDATE:
      return {
        ...state,
        mci: {
          ...state.mci,
          executing: true,
          updated: false,
        },
      };

    case RecordActionTypes.MCI_FINISH_UPDATE:
      return {
        ...state,
        mci: {
          ...state.mci,
          list: state.mci.list.map(r =>
            r.unique_id === action.payload.unique_id && String(r.timestamp) === String(action.payload.timestamp)
              ? action.payload
              : r,
          ),
          current: action.payload,
          executing: false,
          updated: true,
        },
      };

    case RecordActionTypes.MCI_START_DELETE:
      return {
        ...state,
        mci: {
          ...state.mci,
          executing: true,
          deleted: false,
        },
      };

    case RecordActionTypes.MCI_FINISH_DELETE:
      return {
        ...state,
        mci: {
          ...state.mci,
          list: state.mci.list.filter(
            r =>
              !(r.unique_id === action.payload.unique_id && String(r.timestamp) === String(action.payload.timestamp)),
          ),
          current: null,
          executing: false,
          deleted: true,
        },
      };

    case RecordActionTypes.MCI_RESET_FLAGS:
      return {
        ...state,
        mci: {
          ...state.mci,
          created: false,
          updated: false,
          deleted: false,
        },
      };

    // LifeCheck
    case RecordActionTypes.LIFECHECK_START_FETCH:
      return {
        ...state,
        lifecheck: {
          ...state.lifecheck,
          executing: true,
        },
      };

    case RecordActionTypes.LIFECHECK_FINISH_FETCH:
      return {
        ...state,
        lifecheck: {
          ...state.lifecheck,
          list: action.payload,
          executing: false,
          loaded: true,
        },
      };

    case RecordActionTypes.LIFECHECK_START_FETCH_ONE:
      return {
        ...state,
        lifecheck: {
          ...state.lifecheck,
          executing: true,
        },
      };

    case RecordActionTypes.LIFECHECK_FINISH_FETCH_ONE:
      return {
        ...state,
        lifecheck: {
          ...state.lifecheck,
          current: action.payload,
          executing: false,
        },
      };

    case RecordActionTypes.LIFECHECK_START_CREATE:
      return {
        ...state,
        lifecheck: {
          ...state.lifecheck,
          executing: true,
          created: false,
        },
      };

    case RecordActionTypes.LIFECHECK_FINISH_CREATE:
      return {
        ...state,
        lifecheck: {
          ...state.lifecheck,
          list: [...state.lifecheck.list, action.payload],
          executing: false,
          created: true,
        },
      };

    case RecordActionTypes.LIFECHECK_START_UPDATE:
      return {
        ...state,
        lifecheck: {
          ...state.lifecheck,
          executing: true,
          updated: false,
        },
      };

    case RecordActionTypes.LIFECHECK_FINISH_UPDATE:
      return {
        ...state,
        lifecheck: {
          ...state.lifecheck,
          list: state.lifecheck.list.map(r =>
            r.unique_id === action.payload.unique_id && r.sequence === action.payload.sequence ? action.payload : r,
          ),
          current: action.payload,
          executing: false,
          updated: true,
        },
      };

    case RecordActionTypes.LIFECHECK_START_DELETE:
      return {
        ...state,
        lifecheck: {
          ...state.lifecheck,
          executing: true,
          deleted: false,
        },
      };

    case RecordActionTypes.LIFECHECK_FINISH_DELETE:
      return {
        ...state,
        lifecheck: {
          ...state.lifecheck,
          list: state.lifecheck.list.filter(
            r => !(r.unique_id === action.payload.unique_id && r.sequence === action.payload.sequence),
          ),
          current: null,
          executing: false,
          deleted: true,
        },
      };

    case RecordActionTypes.LIFECHECK_RESET_FLAGS:
      return {
        ...state,
        lifecheck: {
          ...state.lifecheck,
          created: false,
          updated: false,
          deleted: false,
        },
      };

    // Barthel
    case RecordActionTypes.BARTHEL_START_FETCH:
      return {
        ...state,
        barthel: {
          ...state.barthel,
          executing: true,
        },
      };

    case RecordActionTypes.BARTHEL_FINISH_FETCH:
      return {
        ...state,
        barthel: {
          ...state.barthel,
          list: action.payload,
          executing: false,
          loaded: true,
        },
      };

    case RecordActionTypes.BARTHEL_START_FETCH_ONE:
      return {
        ...state,
        barthel: {
          ...state.barthel,
          executing: true,
        },
      };

    case RecordActionTypes.BARTHEL_FINISH_FETCH_ONE:
      return {
        ...state,
        barthel: {
          ...state.barthel,
          current: action.payload,
          executing: false,
        },
      };

    case RecordActionTypes.BARTHEL_START_CREATE:
      return {
        ...state,
        barthel: {
          ...state.barthel,
          executing: true,
          created: false,
        },
      };

    case RecordActionTypes.BARTHEL_FINISH_CREATE:
      return {
        ...state,
        barthel: {
          ...state.barthel,
          list: [...state.barthel.list, action.payload],
          executing: false,
          created: true,
        },
      };

    case RecordActionTypes.BARTHEL_START_UPDATE:
      return {
        ...state,
        barthel: {
          ...state.barthel,
          executing: true,
          updated: false,
        },
      };

    case RecordActionTypes.BARTHEL_FINISH_UPDATE:
      return {
        ...state,
        barthel: {
          ...state.barthel,
          list: state.barthel.list.map(r =>
            r.unique_id === action.payload.unique_id && r.record_time === action.payload.record_time
              ? action.payload
              : r,
          ),
          current: action.payload,
          executing: false,
          updated: true,
        },
      };

    case RecordActionTypes.BARTHEL_START_DELETE:
      return {
        ...state,
        barthel: {
          ...state.barthel,
          executing: true,
          deleted: false,
        },
      };

    case RecordActionTypes.BARTHEL_FINISH_DELETE:
      return {
        ...state,
        barthel: {
          ...state.barthel,
          list: state.barthel.list.filter(
            r => !(r.unique_id === action.payload.unique_id && r.record_time === action.payload.record_time),
          ),
          current: null,
          executing: false,
          deleted: true,
        },
      };

    case RecordActionTypes.BARTHEL_RESET_FLAGS:
      return {
        ...state,
        barthel: {
          ...state.barthel,
          created: false,
          updated: false,
          deleted: false,
        },
      };

    // MoffTraining (モフトレ)
    case RecordActionTypes.MOFFTRAINING_START_FETCH:
      return {
        ...state,
        mofftraining: {
          ...state.mofftraining,
          executing: true,
        },
      };

    case RecordActionTypes.MOFFTRAINING_FINISH_FETCH:
      return {
        ...state,
        mofftraining: {
          ...state.mofftraining,
          list: action.payload.records,
          executing: false,
          loaded: true,
        },
        trainingMenus: action.payload.menus || state.trainingMenus,
      };

    case RecordActionTypes.MOFFTRAINING_START_FETCH_ONE:
      return {
        ...state,
        mofftraining: {
          ...state.mofftraining,
          executing: true,
        },
      };

    case RecordActionTypes.MOFFTRAINING_FINISH_FETCH_ONE:
      return {
        ...state,
        mofftraining: {
          ...state.mofftraining,
          current: action.payload,
          executing: false,
        },
      };

    case RecordActionTypes.MOFFTRAINING_START_CREATE:
      return {
        ...state,
        mofftraining: {
          ...state.mofftraining,
          executing: true,
          created: false,
        },
      };

    case RecordActionTypes.MOFFTRAINING_FINISH_CREATE:
      return {
        ...state,
        mofftraining: {
          ...state.mofftraining,
          list: [...state.mofftraining.list, action.payload],
          executing: false,
          created: true,
        },
      };

    case RecordActionTypes.MOFFTRAINING_START_UPDATE:
      return {
        ...state,
        mofftraining: {
          ...state.mofftraining,
          executing: true,
          updated: false,
        },
      };

    case RecordActionTypes.MOFFTRAINING_FINISH_UPDATE:
      return {
        ...state,
        mofftraining: {
          ...state.mofftraining,
          list: state.mofftraining.list.map(r =>
            r.user_id === action.payload.user_id && r.started_at === action.payload.started_at ? action.payload : r,
          ),
          current: action.payload,
          executing: false,
          updated: true,
        },
      };

    case RecordActionTypes.MOFFTRAINING_START_DELETE:
      return {
        ...state,
        mofftraining: {
          ...state.mofftraining,
          executing: true,
          deleted: false,
        },
      };

    case RecordActionTypes.MOFFTRAINING_FINISH_DELETE:
      return {
        ...state,
        mofftraining: {
          ...state.mofftraining,
          list: state.mofftraining.list.filter(
            r => !(r.user_id === action.payload.user_id && r.started_at === action.payload.started_at),
          ),
          current: null,
          executing: false,
          deleted: true,
        },
      };

    case RecordActionTypes.MOFFTRAINING_RESET_FLAGS:
      return {
        ...state,
        mofftraining: {
          ...state.mofftraining,
          created: false,
          updated: false,
          deleted: false,
        },
      };

    default:
      return state;
  }
}
